import * as AvatarPrimitive from '@radix-ui/react-avatar'
import { type VariantProps } from 'class-variance-authority'
import * as React from 'react'

import { cn } from '@/lib/ui/style-helpers'

import type { AvatarColor, AvatarSize } from './types'
import { avatarVariants } from './variants'

export interface AvatarProps
  extends
    Omit<React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Root>, 'color'>,
    VariantProps<typeof avatarVariants> {
  size?: AvatarSize
  color?: AvatarColor
}

export const Avatar = React.forwardRef<React.ElementRef<typeof AvatarPrimitive.Root>, AvatarProps>(
  ({ className, size, color, ...props }, ref) => (
    <AvatarPrimitive.Root
      ref={ref}
      className={cn(avatarVariants({ size, color: color ?? 'default' }), className)}
      {...props}
    />
  ),
)

Avatar.displayName = AvatarPrimitive.Root.displayName
